/* MBG Imaged Assertion
   Two behaviours, both driven from the markup:
   - the read more button reveals the collapsed points;
   - a point that carries its own image activates the matching media layer on click,
     and a second click on the same point brings the section image back. */
(function () {
    'use strict';

    var ROOT_SELECTOR = '[data-mbg-ia]';
    var TOGGLE_SELECTOR = '[data-mbg-ia-toggle]';
    var SWITCH_SELECTOR = '[data-mbg-ia-target]';
    var LAYER_SELECTOR = '[data-mbg-ia-layer]';
    var EXPANDED_CLASS = 'is-expanded';
    var ACTIVE_CLASS = 'is-active';
    var DEFAULT_LAYER = 'default';

    function toArray(list) {
        return Array.prototype.slice.call(list);
    }

    function MbgImagedAssertion(root) {
        this.root = root;
        this.toggleButton = root.querySelector(TOGGLE_SELECTOR);
        this.switches = toArray(root.querySelectorAll(SWITCH_SELECTOR));
        this.layers = toArray(root.querySelectorAll(LAYER_SELECTOR));

        this.onToggle = this.handleToggle.bind(this);
        this.onSwitch = this.handleSwitch.bind(this);

        this.init();
    }

    MbgImagedAssertion.prototype.init = function () {
        if (this.toggleButton) {
            this.toggleButton.addEventListener('click', this.onToggle);
        }

        this.switches.forEach(function (button) {
            button.addEventListener('click', this.onSwitch);
        }, this);
    };

    MbgImagedAssertion.prototype.destroy = function () {
        if (this.toggleButton) {
            this.toggleButton.removeEventListener('click', this.onToggle);
        }

        this.switches.forEach(function (button) {
            button.removeEventListener('click', this.onSwitch);
        }, this);
    };

    MbgImagedAssertion.prototype.isExpanded = function () {
        return this.root.classList.contains(EXPANDED_CLASS);
    };

    MbgImagedAssertion.prototype.setExpanded = function (expanded) {
        var button = this.toggleButton;

        if (!button || expanded === this.isExpanded()) {
            return;
        }

        if (expanded) {
            this.root.classList.add(EXPANDED_CLASS);
        } else {
            this.root.classList.remove(EXPANDED_CLASS);
        }

        var label = expanded ? button.getAttribute('data-label-less') : button.getAttribute('data-label-more');

        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        if (label) {
            button.textContent = label;
        }
    };

    MbgImagedAssertion.prototype.handleToggle = function () {
        this.setExpanded(!this.isExpanded());
    };

    MbgImagedAssertion.prototype.handleSwitch = function (event) {
        var button = event.currentTarget;
        var pressed = button.getAttribute('aria-pressed') === 'true';

        this.activate(pressed ? DEFAULT_LAYER : button.getAttribute('data-mbg-ia-target'));
    };

    /* Shows the layer with the given name. An unknown name keeps the current picture. */
    MbgImagedAssertion.prototype.activate = function (name) {
        var target = null;

        this.layers.forEach(function (layer) {
            if (layer.getAttribute('data-mbg-ia-layer') === name) {
                target = layer;
            }
        });

        if (!target) {
            return;
        }

        this.layers.forEach(function (layer) {
            if (layer === target) {
                layer.classList.add(ACTIVE_CLASS);
            } else {
                layer.classList.remove(ACTIVE_CLASS);
            }
        });

        this.switches.forEach(function (button) {
            var isTarget = button.getAttribute('data-mbg-ia-target') === name;

            button.setAttribute('aria-pressed', isTarget ? 'true' : 'false');
        });
    };

    function initAll(scope) {
        var container = scope || document;

        toArray(container.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
            if (root.mbgImagedAssertion) {
                return;
            }

            root.mbgImagedAssertion = new MbgImagedAssertion(root);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initAll();
        });
    } else {
        initAll();
    }

    /* Theme editor support */
    document.addEventListener('shopify:section:load', function (event) {
        initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
        var root = event.target.querySelector(ROOT_SELECTOR);

        if (root && root.mbgImagedAssertion) {
            root.mbgImagedAssertion.destroy();
            root.mbgImagedAssertion = null;
        }
    });

    /* Selecting a point in the editor opens the list and previews that point's image. */
    document.addEventListener('shopify:block:select', function (event) {
        var root = event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;

        if (!root || !root.mbgImagedAssertion) {
            return;
        }

        root.mbgImagedAssertion.setExpanded(true);

        var button = event.target.querySelector(SWITCH_SELECTOR);

        if (button) {
            root.mbgImagedAssertion.activate(button.getAttribute('data-mbg-ia-target'));
        }
    });
})();
